import { Grid } from '@material-ui/core';
import { DashboardRounded, Home } from '@material-ui/icons';
import { useBaseStore } from '@roc/feature-app-core';
import {
  useBorrowerLoansStore,
} from '@roc/feature-borrower-loans';
import {
  ReviseScopeOfWorkShared,
} from '@roc/feature-draws';
import { useLoanRoutes } from '@roc/feature-loans-routes-config';
import { LoanDetailsPaperLayout } from '@roc/feature-loans-shared';
import { observer } from 'mobx-react';
import { useEffect } from 'react';

export const BorrowerReviseScopeOfWork = observer(({ loanId }) => {
  const { globalStore } = useBaseStore();
  const { breadCrumbsStore } = globalStore;

  const { loanRoutesConfig } = useLoanRoutes();

  useEffect(() => {
    breadCrumbsStore.setBreadCrumbItems([
      {
        link: true,
        title: 'Dashboard',
        url: globalStore.routeBaseUrl,
        icon: <DashboardRounded />,
      },
      {
        link: true,
        title: `Loan# ${loanId}`,
        url: loanRoutesConfig.loans(loanId).url,
      },
      {
        link: false,
        title: 'Revise Scope of Work',
      },
    ]);
  });

  return (
    <LoanDetailsPaperLayout title="REVISE SCOPE OF WORK">
      <Grid container xs={12}>
        <ReviseScopeOfWorkShared loanId={loanId} />
      </Grid>
    </LoanDetailsPaperLayout>
  );
});